// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/977bccfcf4ffd4a121d1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"6a733850d3bf308743bf","190":"4b10b600613bfc30bac6","192":"f278dd2babc4db209b14"}[chunkId] + ".chunk.js";
};